export default __webpack_public_path__ + "static/ayvakit-logo-25mg-tablets-a0813151458307ab1e8896d7a992c2b1.png";